module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdqdxOH///9Hj8dgns7n8PjO4fCpy+V4rdaRvN1Ul8vC2uy20una6fTz+PuTVMC9AAAAB3RSTlMAYL8AIM/vi50ITwAAAKlJREFUeF7t2EcOwkAUg+GpeVPSKfc/KhMEQhGwiJ7ZIP8H+Pa22bJOFDnrW8b7EEVZDBsUOlHXhQZFARS9sQLJGoeBnBFQ/wYRquk85l4P9UPZmtRQc+4lJTSXRxcllMszQvsIESJEiBAhQoTGV6dlVUC7rj0GalIFQSWhoHwQSiiofoPWg5Asn53p+BaZh3dmWH64jggRgp0ssNsHdUTBrjHkWddC3Ic3OL2T/X1XdBEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1f1.png
// module id = 605
// module chunks = 0